import React from 'react';
import { useTranslation } from 'react-i18next';
import Language from '@assetsJsModule/common/Language';

export const BackLink = () => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    const language = new Language();

    return (
        <div className="vacancy-offer-back-link">
            <a
                href={`/v2/${language.getCurrentLanguage()}/career`}
                target="_self"
            >
                <span className="glyphicon glyphicon-chevron-left vacancy-offer-glyphicon" />
                {t('common.see_all_positions')}
            </a>
        </div>
    );
};
